module.exports = __webpack_public_path__ + "img/attrezzatura.82574374.jpg";